// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconHolder_Wb1qO {
  background : var( --background );/*rgba( 0, 0, 0, 0.05 );*/
  border:1px solid rgba( 0, 0, 0, 0.25 );
  border-radius: 4px;
  width : 40px;
  height : 40px;
  display : flex;
  align-items:center;
  justify-content:center;
}
.iconHolder_Wb1qO .icon_KBcXv {
  width : 32px;
  height : 32px;
}

.iconHolder_Wb1qO .noIcon_VOL8u {
  color : rgba( 0, 0, 0, 0.5 );
  font-size : 9px;
  white-space: normal;
  text-align : center;
  margin : 4px;
}


.iconHolder_Wb1qO.hasIcon_rQgq6 {
  background : var( --background );
}

.fontOptions_cvUaj {
  display : flex;
  align-items : center;
  justify-content:flex-start;  
}

.unitOptions_VUJbo {
  text-transform: capitalize;
}

.unitOptionsGroup_TDgck {
  margin-top: 8px;
}

.checkbox_lTc0U {
  margin-left : 0px;
}

.addMetadataButton_AARIJ {
  margin-left : 0px;
}

.inset_iFLyv { 
  width : 100%;
}

.pad_rcbKU {
  padding: var( --size-padMedium );
}

.forwardData_JE0E2 {
  max-width: 18px;
}`, "",{"version":3,"sources":["webpack://./src/editors/attributes/style.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC,CAAC,yBAAyB;EAC1D,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import \"../../style/theme.css\";\n\n.iconHolder {\n  background : var( --background );/*rgba( 0, 0, 0, 0.05 );*/\n  border:1px solid rgba( 0, 0, 0, 0.25 );\n  border-radius: 4px;\n  width : 40px;\n  height : 40px;\n  display : flex;\n  align-items:center;\n  justify-content:center;\n}\n.iconHolder .icon {\n  width : 32px;\n  height : 32px;\n}\n\n.iconHolder .noIcon {\n  color : rgba( 0, 0, 0, 0.5 );\n  font-size : 9px;\n  white-space: normal;\n  text-align : center;\n  margin : 4px;\n}\n\n\n.iconHolder.hasIcon {\n  background : var( --background );\n}\n\n.fontOptions {\n  display : flex;\n  align-items : center;\n  justify-content:flex-start;  \n}\n\n.unitOptions {\n  text-transform: capitalize;\n}\n\n.unitOptionsGroup {\n  margin-top: 8px;\n}\n\n.checkbox {\n  margin-left : 0px;\n}\n\n.addMetadataButton {\n  margin-left : 0px;\n}\n\n.inset { \n  width : 100%;\n}\n\n.pad {\n  padding: var( --size-padMedium );\n}\n\n.forwardData {\n  max-width: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconHolder": `iconHolder_Wb1qO`,
	"icon": `icon_KBcXv`,
	"noIcon": `noIcon_VOL8u`,
	"hasIcon": `hasIcon_rQgq6`,
	"fontOptions": `fontOptions_cvUaj`,
	"unitOptions": `unitOptions_VUJbo`,
	"unitOptionsGroup": `unitOptionsGroup_TDgck`,
	"checkbox": `checkbox_lTc0U`,
	"addMetadataButton": `addMetadataButton_AARIJ`,
	"inset": `inset_iFLyv`,
	"pad": `pad_rcbKU`,
	"forwardData": `forwardData_JE0E2`
};
export default ___CSS_LOADER_EXPORT___;
